module.exports = __webpack_public_path__ + "static/20230619_197-d65dbf7c14bda023902987e73126b451.jpg";